import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). Plain objects (not
// StyleSheet) because reactjs-popup takes DOM-style objects on web.
const makeStyles = colors => ({
  menuIconContainer: {
    ...CommonStyles.p_8,
    ...CommonStyles.mh_12,
  },
  content: {
    ...CommonStyles.br_16,
    backgroundColor: colors.surfaceElevated,
    boxShadow: '1px 1px 5px 5px rgba(0, 0, 0, 0.1)',
  },
});

export default makeStyles;
